export const VIEW_SELECT_OPTIONS = {
  BASELINE: {
    value: 1,
    title: 'Baseline'
  },
  DELTA: {
    value: 2,
    title: 'Delta'
  },
  TOTAL: {
    value: 3,
    title: 'Total'
  }
};

export default VIEW_SELECT_OPTIONS;
